/**
 * Buscar una pantalla por su nombre.
 *
 * Está separada del componente para poder probarla sin montar nada: es la única parte del buscador
 * que tiene reglas —qué ordena antes que qué— y las reglas se prueban, no se miran.
 */

/**
 * Para comparar lo que se escribe con lo que dice la pantalla.
 *
 * Sin acentos y en minúsculas: quien busca «importacion» apurado tiene que encontrar «Importación».
 * Pedirle el acento a alguien que está escribiendo para llegar rápido es pedirle que escriba
 * despacio, que es lo contrario de para qué existe esto.
 */
export function normalizar(texto: string): string {
  return texto.normalize('NFD').replaceAll(/[̀-ͯ]/g, '').toLowerCase().trim();
}

/**
 * Las pantallas que coinciden, ordenadas por lo útil que es cada coincidencia.
 *
 * **Las que empiezan con lo escrito van primero.** Quien teclea «pr» quiere Precios, y sin esta
 * regla vería antes Proveedores por venir antes en el menú: el orden del menú no dice nada sobre
 * lo que la persona está buscando.
 *
 * Adentro de cada montón se respeta el orden del menú, que es el único criterio honesto que queda:
 * inventar un peso por «relevancia» sería adivinar.
 */
export function buscar<T extends { readonly nombre: string }>(
  candidatas: readonly T[],
  texto: string,
): T[] {
  const buscado = normalizar(texto);
  if (buscado === '') return [...candidatas];

  const empiezan: T[] = [];
  const contienen: T[] = [];
  for (const candidata of candidatas) {
    const nombre = normalizar(candidata.nombre);
    if (nombre.startsWith(buscado)) empiezan.push(candidata);
    else if (nombre.includes(buscado)) contienen.push(candidata);
  }
  return [...empiezan, ...contienen];
}
